import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Fallback URL if env var is missing
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}/dj-rest-auth/password/reset/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Un email de réinitialisation a été envoyé.');
            } else {
                // Determine error message
                if (data.email) {
                    setError(data.email[0]);
                } else {
                    setError('Une erreur est survenue. Vérifiez l\'adresse email.');
                }
            }
        } catch (err) {
            console.error("Password Reset Error:", err);
            setError('Impossible de contacter le serveur.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-card">
                <h1 className="forgot-password-title">Mot de passe oublié</h1>
                <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.95rem' }}>
                    Entrez votre adresse email ci-dessous. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            className="input-field"
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {message && <div className="success-message">{message}</div>}
                    {error && <div className="error-message">{error}</div>}

                    <button type="submit" className="reset-btn" disabled={loading}>
                        {loading ? 'Envoi...' : 'Envoyer le lien'}
                    </button>
                </form>

                <button onClick={() => navigate('/connexion')} className="back-link" style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
                    Retour à la connexion
                </button>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
